'use strict';

var processInclude = require('base/util');
window.jQuery = window.$ = require('jquery');

$(document).ready(() => {
    processInclude(require('./gtm/gtm'));
});
